export const all = [
  {
    'key': '',
    'value': '',
    'text': 'TODOS',
  },
];
